import { AUTH_SESSION_KEY, AUTH_USER_KEY, POST_LOGIN_REDIRECT_KEY } from "@/lib/auth-helpers";
import type { AxiosError, AxiosResponse } from "axios";
import { classifyHttpError } from "./errors";
import type { HttpClientDependencies, InternalHttpRequestConfig } from "./types";

interface ErrorResponse {
  message?: string;
}

type Notifications = NonNullable<HttpClientDependencies["notifications"]>;

export class HttpFeedback {
  constructor(
    private readonly storage: Storage,
    private readonly notifications: Notifications,
    private readonly redirect: (path: string) => void,
    private readonly currentPath: () => string,
  ) {}

  onSuccess(response: AxiosResponse): void {
    const config = response.config as InternalHttpRequestConfig;
    if (config.toastConfig?.showSuccess !== false && config.toastConfig?.successMessage) {
      this.notifications.success(config.toastConfig.successMessage);
    }
  }

  onError(error: AxiosError): void {
    const kind = classifyHttpError(error);
    if (kind === "cancelled") return;
    const config = error.config as InternalHttpRequestConfig | undefined;
    if (
      kind === "unauthorized" &&
      config?.authMode !== "none" &&
      config?.url !== "/api/v1/auth/login"
    ) {
      this.expireSession();
      return;
    }
    if (config?.toastConfig?.showError === false) return;
    const customMessage = config?.toastConfig?.errorMessage;
    const responseMessage = (error.response?.data as ErrorResponse | undefined)?.message;
    const message =
      customMessage ??
      (kind === "server"
        ? "Erro do servidor. Por favor, tente novamente mais tarde."
        : responseMessage || "Ocorreu um erro interno inesperado no sistema.");
    this.notifications.error(message);
  }

  private expireSession(): void {
    let path = "/";
    try {
      path = this.currentPath();
    } catch {
      // A navegação pode estar indisponível durante o encerramento da sessão.
    }
    this.notifications.warning("Sessão expirada. Por favor, faça login novamente.", {
      id: "session-expired",
    });
    this.storage.removeItem("access_token");
    this.storage.removeItem("refresh_token");
    this.storage.removeItem(AUTH_SESSION_KEY);
    this.storage.removeItem("isLoggedIn");
    this.storage.removeItem(AUTH_USER_KEY);
    if (path !== "/login") this.storage.setItem(POST_LOGIN_REDIRECT_KEY, path);
    this.redirect("/login");
  }
}
